import { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

export const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Volver arriba"
      data-testid="scroll-to-top-button"
      className={`fixed bottom-[calc(1.5rem+5vh)] right-6 sm:bottom-[calc(2rem+5vh)] sm:right-8 z-40 w-12 h-12 sm:w-14 sm:h-14 rounded-full flex items-center justify-center shadow-[0_18px_40px_rgba(0,0,0,0.35)] transition-all duration-300 hover:scale-110 hover:-translate-y-1 ${
        visible
          ? 'opacity-100 translate-y-0 pointer-events-auto'
          : 'opacity-0 translate-y-3 pointer-events-none'
      }`}
      style={{ backgroundColor: '#E95526', color: '#fff' }}
    >
      <ArrowUp size={22} strokeWidth={2.5} />
    </button>
  );
};
